import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from "@material-ui/core/styles";

import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import DragHandleIcon from '@material-ui/icons/DragHandle';

const useStyles = makeStyles(theme => ({
    root: {
        height: '28mm',
        width: '30mm',
        padding: 4
    },

    paper: {
        padding: '0px',
        margin: '0 0 0 0',
        boxShadow: 'none',
        borderRadius: 3,
        width: 'auto',
        height: '100%',
        backgroundColor: '#efefef'
    },
  container: {
    display: 'inline-block',
    width: '100%',
    margin: 'auto',
      padding: '0px'
  },

    gridValor: {
        marginTop: 5,
        display: "flex",
        height: '15mm',
        justifyContent: 'center',
        alignItems: 'center'

    },

    gridTitulo: {
        display: "flex",
        height: '6mm',
        justifyContent: 'center',
        alignItems: 'center'

    },
    gridComparativo: {
        display: "flex",
        height: '6mm',
        justifyContent: 'center',
        alignItems: 'center',
        // backgroundColor: 'cyan',
        verticalAlign: "middle",
        margin: 0,
        padding: 0

    },
    gridDescricao: {
        display: "flex",
        justifyContent: 'center'
    },
  row: {
    //padding: '2px !important'
      justifyContent: 'center'

  },
  textcenter: {
      textAlign: 'center',
      justify: 'center'
  }

}));

const  KpiGrid = (props) => {
    const classes = useStyles();
    const {  valor, unidadeValor, titulo, descricao, valorBase   } = props;

    const inverso = props.inverso? props.inverso : false;

    let diferenca = 0;
    let pBase = false;
    if (typeof(valorBase) !== "undefined" && valorBase !== null ) {
        pBase = true;
        if (valorBase < valor) {
            diferenca = Math.round(((valor / valorBase) - 1) * 100);
        } else {
            diferenca =  Math.round((1-(valor / valorBase)) * 100) * -1;
        }
    }

    const icon = () => {
        if (!pBase) { return (<React.Fragment/>); }
        if (valor === valorBase) { return(<React.Fragment/>);}
        if (!inverso) {
            if (valor>valorBase) { return (<ArrowUpwardIcon   style={{ verticalAlign: "middle", color: "green"}} />);} else {return(<ArrowDownwardIcon style={{ verticalAlign: "middle", color: "red"}} />);}
        } else {
            if (valor<valorBase) { return (<ArrowUpwardIcon  style={{ verticalAlign: "middle", color: "green"}} />);} else {return(<ArrowDownwardIcon  style={{ verticalAlign: "middle", color: "red"}} />);}
        }
    }


    return (
        <Grid item className={classes.root}>
            <Paper className={classes.paper}>
                <Grid container  className={classes.container}>
                    <Grid item className={classes.gridValor }>
                        <Typography  variant="h4" style={{display: 'inline-block', fontSize: '36px'}}>
                            {valor}
                        </Typography>
                        <Typography  variant="caption" style={{display: 'inline-block', fontSize: '24px'}}>
                            {unidadeValor}
                        </Typography>

                    </Grid>
                    <Grid container item className={classes.gridTitulo}>
                        <Typography gutterBottom variant="h5" style={{ fontSize: '14px', fontWeight: 500}}>
                            {titulo}
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );
}



export default (KpiGrid);
